module.exports = __webpack_public_path__ + "static/media/default_company.c6a2afd7.png";